export enum LiftType {
  NoMove = 'no-move',
  UpWithLift = 'up-with-lift',
  UpWithoutLift = 'up-without-lift',
  DownWithLift = 'down-with-lift',
  DownWithoutLift = 'down-without-lift'
}
